var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._b(
      {
        staticClass: "ico icon fi",
        class: _vm.extraClass,
        attrs: {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.75",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          width: _vm.svgSize,
          height: _vm.svgSize,
          "aria-hidden": _vm.labelled ? "false" : "true",
          focusable: "false",
        },
        domProps: { innerHTML: _vm._s(_vm.inner) },
      },
      "svg",
      _vm.svgAttrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }